export default "__VITE_ASSET__C3B48rcN__"